import { HocOptions } from '../generic-hoc.types';
import GenericHoc from '../generic-hoc';
import React from 'react';
import { NAVBAR_HEIGHT } from 'library/globals';
import { mobileMenuItems } from './side-menu.constants';
import { Routes } from 'library/constants';
import Helper from 'library/Helper';
import useIsMobile from 'hooks/useIsMobile';
import { ReduxStore } from 'reducers/redux.types';

const styles = () => ({
    main: {
        height: NAVBAR_HEIGHT,
        display: 'flex',
        width: '100%',
        justifyContent: 'space-around',
        background: '#fff',
        alignItems: 'center',
        flexShrink: 0,
    },
});

const MobileMenu = (props: any) => {
    const {
        classes,
        location,
        history,
        uiTheme,
    } = props;
    const [current, setCurrent] = React.useState<any>({ key: Routes.CONSIGNMENTS });
    const isMobile = useIsMobile();
    React.useEffect(() => {
        let currentPage: any | undefined;
        switch (Helper.getCurrentRoute()) {
            case Routes.PICKUPS:
                currentPage = Routes.PICKUPS;
                break;
            case Routes.SETTINGS_ACCOUNT:
                currentPage = Routes.SETTINGS_ACCOUNT;
                break;
            case Routes.ANALYTICS:
                currentPage = Routes.ANALYTICS;
                break;
            case Routes.CONSIGNMENTS:
            default:
                currentPage = Routes.CONSIGNMENTS;
                break;
        }
        setCurrent(currentPage || current);
    }, [location, isMobile]);


    const handleTabChange = (route: string) => {
        history.push(route);
    };
    return (
        <div className={classes.main}>
            {
                mobileMenuItems.map((item) => {
                    const Icon = item.icon;
                    return (
                        <div
                            style={{
                                color: current === item.key ? uiTheme.primaryColor : '#111111',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                fontSize: 14,
                                fontWeight: 600,
                            }}
                            key={item.key}
                            className="menu-item"
                            onClick={() => handleTabChange(item.route)}
                        >
                            {Icon && <Icon style={{ fontSize: 20, marginBottom: 2 }} />}
                            <span>{item.name}</span>
                        </div>
                    );
                })
            }
        </div>
    );
};

const mapStateToProps = (state: ReduxStore) => {
    return {
        uiTheme: state.uiTheme,
    };
};
const hocConfig: HocOptions = {
    connectRouter: true,
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectTranslession: true,
};

export default GenericHoc(hocConfig)(MobileMenu);
